/**
 * A hash router in thirty lines.
 *
 * Six screens, no nested layouts, no data loaders. A routing library would be a
 * dependency to keep current for a navigation problem `location.hash` already
 * solves — and hash routing needs no server rewrite rule, which matters for an
 * internal tool that may end up served from a static path behind a VPN.
 */
import { useEffect, useState } from 'react';

export function currentRoute(): string {
  const hash = window.location.hash.replace(/^#\/?/, '');
  return hash === '' ? 'dashboard' : hash;
}

export function useRoute(): string {
  const [route, setRoute] = useState(currentRoute);

  useEffect(() => {
    const onChange = (): void => setRoute(currentRoute());
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);

  return route;
}

export function navigate(route: string): void {
  window.location.hash = `#/${route}`;
}
